export const ADD_NEW_VPA_TEST_IDS = {
    UPI_ID_INPUT: "upi_input",
    SAVE_UPI_CHECKBOX: "save_upi_tick",
    SAVE_UPI_TEXT: "save_upi_text",
    VERIFY_AND_PAY_BUTTON: "verify_btn",
    HOW_UPI_WORKS_TITLE: "huw_title",
    HOW_UPI_WORKS_CONTENT: "huw_content",
    BOTTOM_ICON: "bottom_icon",
};
